
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { CardDialog } from './CardDialog';
import { MobileCardCreator } from '@/components/mobile/MobileCardCreator';
import { useTheme } from '@/contexts/ThemeContext';
import { useIsMobile } from '@/hooks/use-mobile';

interface CreateCardButtonProps {
  columnId: string;
}

export const CreateCardButton = ({ columnId }: CreateCardButtonProps) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { isDarkMode } = useTheme();
  const isMobile = useIsMobile();

  // Create a mock card object for new card creation
  const newCard = {
    id: '',
    title: '',
    description: '',
    column_id: columnId,
    position: 0,
    start_date: null,
    end_date: null,
    tags: null,
    category: null,
    assigned_to: null,
    created_by: '',
    created_at: '',
    updated_at: '',
    progress_state: 'not_started',
    checklists: null,
    archived: false,
    last_edited_by: null,
    version: 1,
  };

  // Mobile-specific styling and functionality
  if (isMobile) {
    return (
      <>
        <Button
          onClick={() => setDialogOpen(true)}
          className="w-full bg-primary text-primary-foreground hover:bg-primary/90 h-12 text-base font-medium"
        >
          <Plus className="h-5 w-5 mr-2" />
          Add Card
        </Button>

        <MobileCardCreator
          open={dialogOpen}
          onOpenChange={setDialogOpen}
          columnId={columnId}
        />
      </>
    );
  }

  // Desktop styling (existing)
  const buttonClass = isDarkMode 
    ? "w-full h-10 border-transparent border-gray-300 text-gray-500 hover:border-gray-400 hover:text-gray-600 hover:bg-gray-50" 
    : "w-full h-10 border-transparent bg-white text-black hover:border-green-400 hover:bg-green-400 hover:text-white";

  return (
    <>
      <Button
        variant="ghost"
        onClick={() => setDialogOpen(true)}
        className={buttonClass}
      >
        <Plus className="h-4 w-4 mr-2" />
        Add Card
      </Button>

      <CardDialog
        card={newCard}
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        isCreateMode={true}
      />
    </>
  );
};
